const sortDates = (dates, reverse = false) => {
	dates.sort((a, b) => new Date(b.dates.end_datetime) - new Date(a.dates.end_datetime));
	if (reverse) dates.reverse();
};

const buildRepeatableEvents = (events) => {
	events.forEach((event) => {
		// if the there are multiple dates in event.date array check if one of the dates is in the future if yes set this start and end timestamp as new date array
		if (event.repeating) {
			for (const element of event.repeating) {
				// if there is a date in the future set this as new date array
				const endDate = new Date(element.end_datetime);
				if (endDate > new Date()) {
					// set the new date array
					event.dates = { start_datetime: element.start_datetime, end_datetime: element.end_datetime };

					// Set the links for the event
					event.links = element.links;

					// stop the loop if a date is found
					break;
				} else {
					// Set the last date as the date array
					event.dates = element;

					// Set the links for the event
					event.links = element.links;
				}
			}
		}
	});

	return events;
};

const removeAlwaysAvailableEvents = (events) => {
	return events.filter((event) => {
		return event.dates.start_datetime !== null && event.dates.end_datetime !== null;
	});
};

const filterEvents = (timeFilter, events) => {
	switch (timeFilter) {
		case 'upcoming_events':
			// Remove always available events from the list.
			events = removeAlwaysAvailableEvents(events);

			// Build the repeating events.
			events = buildRepeatableEvents(events);

			// Get all upcoming events with the same category filtered by the API.
			events = events.filter((event) => new Date(event.dates.end_datetime) > new Date());

			// Sort the most recent events to display first.
			sortDates(events, true);

			return events;
		case 'past_events':
			// Remove always available events from the list.
			events = removeAlwaysAvailableEvents(events);

			// Build the repeating events.
			events = buildRepeatableEvents(events);

			// Provides events that took place in the past.
			events = events.filter((event) => new Date(event.dates.end_datetime) < new Date());

			// Sorts the past events in descending order, according to when they were held.
			sortDates(events);

			// Reduce the amount of past events to a maximum of 20.
			events = events.slice(0, 20);

			return events;
		case 'always_available_events':
			// Reduce the amount of past events to a maximum of 20.
			events = events.slice(0, 20);

			// Return all events.
			return events;
	}
};

export { buildRepeatableEvents, filterEvents, removeAlwaysAvailableEvents, sortDates };
